var map = {
	"./MainProjects/blog.png": 7663,
	"./MainProjects/blog.webp": 8072,
	"./MainProjects/chatF.png": 7617,
	"./MainProjects/chatF.webp": 3236,
	"./MainProjects/coinM.png": 3537,
	"./MainProjects/coinM.webp": 6995,
	"./MainProjects/coroU.png": 9367,
	"./MainProjects/coroU.webp": 2549,
	"./MainProjects/emailer.png": 4804,
	"./MainProjects/emailer.webp": 2727,
	"./MainProjects/file.png": 7534,
	"./MainProjects/file.webp": 9742,
	"./MainProjects/hacker.png": 5945,
	"./MainProjects/hacker.webp": 3009,
	"./MainProjects/opti.png": 4242,
	"./MainProjects/opti.webp": 6471,
	"./MainProjects/queA.png": 5598,
	"./MainProjects/queA.webp": 3161,
	"./MainProjects/sudoK.png": 3059,
	"./MainProjects/sudoK.webp": 5012,
	"./MainProjects/urlShort.png": 7078,
	"./MainProjects/urlShort.webp": 9311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;